import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import PasswordProtection from './components/PasswordProtection';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if user was previously authenticated
    const authStatus = localStorage.getItem('sponsorAuthenticated');
    if (authStatus === 'true') {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, []);

  const handleAuthenticate = (authStatus) => {
    setIsAuthenticated(authStatus);
  };

  // Show loading state briefly
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-proactuary-blue-900 via-proactuary-blue-800 to-proactuary-green-900 flex items-center justify-center">
        <div className="text-white text-xl">Loading...</div>
      </div>
    );
  }

  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-proactuary-blue-900 via-proactuary-blue-800 to-proactuary-green-900">
        {!isAuthenticated ? (
          <PasswordProtection onAuthenticate={handleAuthenticate} />
        ) : (
          <Routes>
            <Route path="/" element={<Dashboard />} />
          </Routes>
        )}
      </div>
    </Router>
  );
}

export default App;